import styled from "styled-components";

export const ButtonWrapper = styled.div`
  position: absolute;
  z-index: 1;
  right: ${(props) => (props.right ? `${props.right}px` : "10px")};
  top: ${(props) => (props.right ? `${props.top}px` : "10px")};
  box-shadow: 0 0 10px #d2d2d2;
  border-radius: 50%;
`;

export const Button = styled.div`
  width: 27px;
  height: 27px;
  border-radius: 50%;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 1px solid #fff;
  transition: 0.1s ease-in-out;

  svg {
    color: #f2008c;
    transition: 0.1s ease-in-out;
    font-size: 0.87em;
  }

  &:hover {
    background-color: #673490;

    svg {
      color: #fff;
    }
  }
`;
